import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState, type ReactNode } from "react";
import { cn } from "../lib/utils";

/**
 * Пост картинками на проверке (08.10.2026): та же тёмная колонка, что у
 * плеера, только листаются картинки — по одной, в порядке карусели.
 */
export function ImageCarousel({ images, header, className, onIndex, seek }: {
  images: { url: string | null; name: string }[];
  header?: ReactNode;
  className?: string;
  /** какой слайд открыт (с 0) — к нему привязывается правка */
  onIndex?: (i: number) => void;
  /** перейти к слайду: `t` — номер с 1, `n` — чтобы повторный переход сработал */
  seek?: { t: number; n: number } | null;
}) {
  const [i, setI] = useState(0);
  const at = Math.min(i, images.length - 1);
  useEffect(() => onIndex?.(at), [at, onIndex]);
  useEffect(() => {
    if (seek) setI(Math.min(images.length - 1, Math.max(0, seek.t - 1)));
  }, [seek, images.length]);
  const cur = images[at];
  return (
    <div className={cn("flex h-full w-[340px] shrink-0 flex-col items-center justify-center gap-3.5 bg-player p-5", className)}>
      {header && <div className="flex w-full items-center gap-1.5">{header}</div>}
      <div className="relative flex min-h-0 w-full flex-1 items-center justify-center overflow-hidden rounded-[22px] bg-black/40">
        {cur?.url ? (
          <img src={cur.url} alt={cur.name} className="max-h-full max-w-full object-contain" draggable={false} />
        ) : (
          <span className="text-xs text-white/60">Файл недоступен</span>
        )}
        {images.length > 1 && (
          <>
            <button type="button" onClick={() => setI(Math.max(0, at - 1))} disabled={at === 0} aria-label="Предыдущая картинка"
              className="absolute left-2 top-1/2 grid size-9 -translate-y-1/2 place-items-center rounded-full bg-black/55 text-white disabled:opacity-30">
              <ChevronLeft className="size-5" />
            </button>
            <button type="button" onClick={() => setI(Math.min(images.length - 1, at + 1))} disabled={at === images.length - 1} aria-label="Следующая картинка"
              className="absolute right-2 top-1/2 grid size-9 -translate-y-1/2 place-items-center rounded-full bg-black/55 text-white disabled:opacity-30">
              <ChevronRight className="size-5" />
            </button>
          </>
        )}
      </div>
      <div className="flex items-center gap-1.5">
        {images.map((_, k) => (
          <button key={k} type="button" onClick={() => setI(k)} aria-label={`Картинка ${k + 1}`}
            className={cn("size-2 rounded-full", k === at ? "bg-white" : "bg-white/35")} />
        ))}
        <span className="ml-2 text-xs tabular-nums text-white/70">{at + 1} / {images.length}</span>
      </div>
    </div>
  );
}
